/** Unique per-tab client id. */
export function genClientId(): string {
  const c = globalThis.crypto;
  if (c && typeof c.randomUUID === "function") return c.randomUUID();
  return `c_${Math.random().toString(36).slice(2, 12)}`;
}

// Unambiguous alphabet (no 0/o/1/l/i) for shareable, speakable room codes.
const ROOM_ALPHABET = "abcdefghjkmnpqrstuvwxyz23456789";

/** Unguessable short room code (PRD §13: no public index, codes are the gate). */
export function genRoomCode(len = 7, rng: () => number = Math.random): string {
  let s = "";
  for (let i = 0; i < len; i++) {
    s += ROOM_ALPHABET[Math.floor(rng() * ROOM_ALPHABET.length)];
  }
  return s;
}
